import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/Constants";
import {
  fetchMasterList,
  fetchMasterListById,
  addMasterRecord,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import Loader from "../../../../common/Loader";
import { toastFunc } from "../../../../components/common/util";
import { ErrorModal } from "../../../../components/common/errorModal";
import OperatorChecklistConfirmForm from "./OperatorChecklistConfirmForm";

const OperatorChecklist = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [deptCode, setDeptCode] = useState();
  const [deptName, setDeptName] = useState();
  const [machinesData, setMachinesData] = useState();
  const [machineCode, setMachineCode] = useState();
  const [machineName, setMachineName] = useState();
  const [machineStatus, setMachineStatus] = useState();
  const [checkListInfo, setCheckListInfo] = useState();
  const [verifiedCheckList, setVerifiedCheckList] = useState([]);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [confirmModel, setConfirmModel] = useState(false);
  const [daysCheckListRecord, setDaysCheckListRecord] = useState();

  useEffect(() => {
    if(location?.state?.deptCode) {
      handleStartJob(location);
    } else {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT)); // userSlice store
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStartJob =(location) =>{
    setMachineCode(location.state?.machineCode);
    setDeptCode(location.state?.deptCode);
    setMachineName(location.state?.machineName);
    setDeptName(location.state?.deptName);
    fetchChecklistDetails(location.state?.machineCode,location.state?.deptCode);
  }

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  const rowsData = masterList[Constants.MASTER.DEPARTMENT.name]?.data;

  const navigateBack = () => {
    if(location?.state?.jobcardNo){
      setMachineStatus("");
      setVerifiedCheckList([]);
      setDaysCheckListRecord();
      setMachineCode();
      setDeptCode();
      navigate("/startStopJobCard",{
        state: {
          jobcardNo: location?.state?.jobcardNo,
          machineCode: location?.state?.machineCode,
          machineName: location?.state?.machineName,
        }
      });
    } else if(location?.state?.deptCode){
      setMachineStatus("");
      setVerifiedCheckList([]);
      setDaysCheckListRecord();
      setMachineCode();
      setDeptCode();
      navigate("/startStopJobCard",{
        state: {
          deptCode: location?.state?.deptCode,
          machineCode: location?.state?.machineCode,
          machineName: location?.state?.machineName,
        }
      });
    } else if (machineCode) {
      setMachineCode();
      setDeptCode();
    } else if (!deptCode) {
      navigate("/home");
    } else {
      setDeptCode();
    }
    setMachineStatus("");
    setVerifiedCheckList([]);
    setDaysCheckListRecord();
  };

  const onMachineSelect = (value) => {
    setMachineCode(value.machineCode);
    fetchChecklistDetails(value.machineCode);
    fetchOperatorCheckListRecord(value.machineCode);
    setMachineName(value.machineName);
    if (value.status !== "Active") {
      setIsError(true);
      setMachineStatus("InActive");
      setError(
        t("msg_trasaction.msg_operator_checklist.error_machine_inactive")
      );
    }
  };

  const handleViewMachines = (departmentCode) => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = departmentCode;

    if (departmentCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        setMachinesData(result?.payload?.data);
      });
    }
  };

  const fetchOperatorCheckListRecord = (machineCode) => {
    let param = {};
    param.url = "getTodaysOperatorChecklist";
    param.page = Constants.TRANSACTION.OPERATORCHECKLIST.name;
    param.machineCode = machineCode;
    param.deptCode = deptCode;

    if (machineCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        if (result?.payload?.data) {
          setDaysCheckListRecord(result?.payload?.data);
          setIsError(true);
          setError(
            t(
              "msg_trasaction.msg_operator_checklist.error_verificaton_complete"
            )
          );
        }
      });
    }
  };

  const fetchChecklistDetails = (machineCode,departmentCode) => {
    let param = {};
    param.url = "getCheckListByMachine";
    param.machineCode = machineCode;
    param.deptCode = deptCode ? deptCode : departmentCode;

    if (machineCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        setCheckListInfo(result?.payload?.data);
        // eslint-disable-next-line array-callback-return
        result?.payload?.data?.map((checkListType, index) => {
          // eslint-disable-next-line array-callback-return
          checkListType?.records?.map((item, index) => {
            const code = item.checklistCode;

            const obj = {
              [code]: {
                checklistCode: item.checklistCode,
                checklistName: item.checklistName,
                checklistTypeName: item.checklistTypeName,
                verified: true,
              },
            };
            setVerifiedCheckList((prevValue) => ({ ...prevValue, ...obj }));
          });
        });
      });
    }
  };

  const handleSave = () => {
    const checkListObj = {
      deptCode,
      deptName,
      machineCode,
      machineName,
      verifiedCheckList,
    };
    const param = { ...checkListObj };
    param.method = Constants.TRANSACTION.OPERATORCHECKLIST.ADD;

    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_trasaction.msg_operator_checklist.success_message"),
          2000
        );

        dispatch(fetchMasterList(Constants.MASTER.MACHINES)); // userSlice store
        setConfirmModel(false);
        navigateBack();
      } else {
        setError(
          t("msg_trasaction.msg_operator_checklist.error_operator_checklist")
        );
        setIsError(true);
        setConfirmModel(false);
      }
    });
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const handleCheck = (e) => {
    const obj = {
      ...verifiedCheckList,
      [e.target.id]: {
        ...verifiedCheckList[e.target.id],
        verified: !verifiedCheckList[e.target.id].verified,
      },
    };
    setVerifiedCheckList(obj);
  };

  const headerMsg = t("msg_trasaction.msg_operator_checklist.page_title");
  return (
    <main className="generatejobcard main" id="main">
      <Card className="">
        <Card.Header>
          <Button
            type="button"
            variant="primary"
            className="btn btn-primary btn-xs navigateBackButton"
            onClick={() => navigateBack()}
          >
            <i class="bi bi-arrow-left back"> </i>
            <span className="back"> {t("msg_common.Back")}</span>
          </Button>
          <h5 className="machineStatusTitle">{headerMsg}
          </h5>
          { machineCode && (<div className="submsgTitle">{t("msg_trasaction.msg_idle_status.machine") + machineCode + machineName}</div>)}
          { deptCode && (<div className="submsgTitle">{t("msg_trasaction.msg_idle_status.department") + deptCode+deptName}</div>)}
        </Card.Header>
        <Card.Body className="ps-3">
          <Row className="justify-center subContent">
            <Col xs={12} md={12} className="rightSide">
              <div className="rightSideInner timesheet">
                {isError && (
                  <ErrorModal
                    show={isError}
                    heading={t(
                      "msg_trasaction.msg_idle_status.error_updating_machine_status"
                    )}
                    bodyMessage={error}
                    onHide={() => {
                      resetError();
                    }}
                  ></ErrorModal>
                )}
                {machineCode ? (
                  <Row>
                    <Form>
                      <Form.Group
                        as={Row}
                        name="rateType"
                        className="machineIdleRadio"
                        controlId="rateType"
                        onChange={(e) => handleCheck(e)}
                      >
                        {checkListInfo && checkListInfo.length > 0 ? (
                          checkListInfo?.map((checkListType, index) => {
                            return (
                              <div>
                                <Col
                                  xs={12}
                                  md={12}
                                  sm={12}
                                  key={index}
                                  className="checkListType d-flex justify-content-center align-items-center"
                                >
                                  <span className="checkListType">
                                    {checkListType?._id?.toUpperCase()}
                                  </span>
                                </Col>
                                {checkListType?.records?.map((item, index) => {
                                  return (
                                    <Col xs={12} md={12} sm={12} key={index}>
                                      <Form.Check // prettier-ignore
                                        type="switch"
                                        id={item.checklistCode}
                                        label={item.checklistName}
                                        className="checklistSwitch"
                                        value={
                                          verifiedCheckList?.[
                                            item.checklistCode
                                          ]?.verified
                                        }
                                        checked={
                                          verifiedCheckList?.[
                                            item.checklistCode
                                          ]?.verified
                                        }
                                      />
                                    </Col>
                                  );
                                })}
                              </div>
                            );
                          })
                        ) : (
                          <div className="ps-3 ">
                            <h5>
                              {t(
                                "msg_trasaction.msg_operator_checklist.No_checklist"
                              )}
                            </h5>
                          </div>
                        )}
                      </Form.Group>
                    </Form>
                    {confirmModel && (
                      <OperatorChecklistConfirmForm
                        show={confirmModel}
                        onHide={() => setConfirmModel(false)}
                        onConfirm={handleSave}
                      ></OperatorChecklistConfirmForm>
                    )}
                  </Row>
                ) : deptCode ? (
                  <Row>
                    <Loader
                      isLoading={!machinesData}
                      className={"text-center"}
                    />
                    {machinesData?.length > 0 ? (
                      machinesData?.map((value, index) => {
                        const statusInd =
                          value.status === Constants.MASTER.STATUS.Active;
                        return (
                          <Col
                            xs={12}
                            md={4}
                            className="commLeftRightPadding"
                            key={index}
                          >
                            <Card
                              className="machineStatus-card"
                              onClick={() => {
                                onMachineSelect(value);
                              }}
                            >
                              <div
                                className={
                                  statusInd
                                    ? "outline-primary card-body active"
                                    : "card-body in-active"
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <div className="w-10 card-icon ">
                                    <i className="bi bi-tools label"></i>
                                  </div>
                                  <div className="machineStatus-text">
                                    {value.machineCode}: {value.machineName}
                                  </div>
                                  <div className="w-10 card-icon ">
                                    <i class="bi bi-chevron-double-right label"></i>
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        );
                      })
                    ) : (
                      <div className="ps-3 ">
                        <h5>
                          {t("msg_trasaction.msg_idle_status.No_machine")}
                        </h5>
                      </div>
                    )}
                  </Row>
                ) : (
                  <Row>
                    <Loader isLoading={!rowsData} className={"text-center"} />
                    {rowsData?.length > 0
                      ? rowsData?.map((value, index) => {
                          const statusInd =
                            value.status === Constants.MASTER.STATUS.Active;
                          return (
                            <Col
                              xs={12}
                              md={4}
                              className="commLeftRightPadding"
                              key={index}
                            >
                              <Card
                                className="machineStatus-card"
                                onClick={() => {
                                  setDeptCode(value.deptCode);
                                  handleViewMachines(value.deptCode);
                                  setDeptName(value.deptName);
                                }}
                              >
                                <div
                                  className={
                                    statusInd
                                      ? "outline-primary card-body active"
                                      : "card-body in-active"
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="w-10 card-icon">
                                      <i className="bi bi-diagram-2-fill label"></i>
                                    </div>
                                    <div className="machineStatus-text">
                                      {value.deptCode}: {value.deptName}
                                    </div>
                                    <div className="w-10 ">
                                      <i class="bi bi-chevron-double-right label"></i>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </Col>
                          );
                        })
                      : null}
                  </Row>
                )}
              </div>
            </Col>
          </Row>
        </Card.Body>
        {machineCode && checkListInfo && checkListInfo.length > 0 ? (
          <Card.Footer className="text-center machine-status-footer-button">
            <Button
              type="button"
              variant="success"
              size="lg"
              className="btn btn-success"
              disabled={machineStatus === "InActive" || daysCheckListRecord}
              onClick={() => setConfirmModel(true)}
            >
              {t("msg_common.save")}
            </Button>

            <Button
              type="button"
              variant="danger"
              size="lg"
              className="btn btn-danger"
              onClick={() => navigateBack()}
              data-dismiss="modal"
            >
              {t("msg_common.set_cancel")}
            </Button>
          </Card.Footer>
        ) : (
          ""
        )}
      </Card>
    </main>
  );
};

export default OperatorChecklist;
